import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';
  
class AboutUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
    }

    fetchCustomerProfile(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/profile_api2.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                            
            that.setState({ LOADING:false, CUSTOMER_DET:CUSTOMER_DET  });
        });
    }

    handleClickModalLogOut = () => {
        $('#ModalLogout').modal('show');
    }

    handleClickLogOut = () => {
        localStorage.removeItem('userData');
        this.setState({ LoggedOut:true });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }
    
    componentDidMount() {
        var customer = localStorage.getItem('userData');
        this.fetchCustomerProfile('PROFILE',customer);
    }
    
    render() { 

        //console.log(localStorage.getItem('delCity'));
        //console.log(localStorage.getItem('delArea'));

        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'About Us';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = '';
        
        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="section full mt-2">
                        <div className="pr-2 pl-2 pt-2 pb-1 font-size-14">
                            <p>Done Delivery is a Goa-based consumer friendly hyper-local delivery solution provider which delivers your favorite food from your chosen outlet to your doorstep. It is a subsidiary of Palasha Enterprises which is into FMCG distribution business since Aug 2012. Done Delivery's core focus is to be a smooth bridge between partnering restaurants and their customers.</p>
                        </div>
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default AboutUs;


// WEBPACK FOOTER //
// ./src/components/AboutUs.js